const OVERLAY_PORTAL_SELECTOR = [
    '[data-headlessui-portal]',
    '.MuiPickerPopper-root',
    '#tebuto-time-input-dialog',
    '.tebuto-date-picker-popper'
].join(', ')

export function isInsideOverlayPortal(target: EventTarget | null): boolean {
    if (!(target instanceof Node)) {
        return false
    }
    const element = target instanceof Element ? target : target.parentElement
    return Boolean(element?.closest(OVERLAY_PORTAL_SELECTOR))
}
